import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import NewsletterForm from '@/components/feature/NewsletterForm';

export default function Footer() {
  return (
    <footer className="bg-stone-100 dark:bg-stone-900 border-t border-stone-200 dark:border-stone-800 mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="cursor-pointer">
              <span className="text-3xl font-bold text-rose-500"
                style={{ fontFamily: "'Teko', sans-serif" }}>
                roameurope<span className="text-stone-400 dark:text-stone-500">.blog</span>
              </span>
            </Link>
            <p className="mt-3 text-sm text-stone-500 dark:text-stone-400 leading-relaxed max-w-xs">
              Honest, thoughtful writing about love, relationships, and the beautiful complexity of human connection.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-200 dark:bg-stone-800 text-stone-500 dark:text-stone-400 hover:bg-rose-100 dark:hover:bg-rose-900/40 hover:text-rose-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm" />
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-200 dark:bg-stone-800 text-stone-500 dark:text-stone-400 hover:bg-rose-100 dark:hover:bg-rose-900/40 hover:text-rose-500 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm" />
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-200 dark:bg-stone-800 text-stone-500 dark:text-stone-400 hover:bg-rose-100 dark:hover:bg-rose-900/40 hover:text-rose-500 transition-colors cursor-pointer">
                <i className="ri-pinterest-line text-sm" />
              </a>
              <a href="/feed.xml" rel="nofollow" title="RSS Feed" className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-200 dark:bg-stone-800 text-stone-500 dark:text-stone-400 hover:bg-orange-100 dark:hover:bg-orange-900/40 hover:text-orange-500 transition-colors cursor-pointer">
                <i className="ri-rss-line text-sm" />
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-xs font-semibold text-stone-400 dark:text-stone-500 uppercase tracking-widest mb-4">
              <a id="categories-nav">Topics</a>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-stone-500 dark:text-stone-400 hover:text-rose-500 dark:hover:text-rose-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-semibold text-stone-400 dark:text-stone-500 uppercase tracking-widest mb-4">
              <a id="legal-nav">Legal &amp; Info</a>
            </h4>
            <ul className="space-y-2">
              {[
                { to: '/archive', label: 'All Articles' },
                { to: '/about', label: 'About Us' },
                { to: '/contact', label: 'Contact' },
                { to: '/advertise', label: 'Advertise' },
                { to: '/privacy-policy', label: 'Privacy Policy' },
                { to: '/terms', label: 'Terms of Service' },
                { to: '/disclaimer', label: 'Disclaimer' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-stone-500 dark:text-stone-400 hover:text-rose-500 dark:hover:text-rose-400 transition-colors cursor-pointer">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <NewsletterForm variant="footer" />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-stone-200 dark:border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-stone-400 dark:text-stone-500">
            &copy; {new Date().getFullYear()} roameurope.blog — All rights reserved.
          </p>
          <p className="text-xs text-stone-400 dark:text-stone-500">
            Content is for informational purposes only. Not a substitute for professional advice.
          </p>
        </div>
      </div>
    </footer>
  );
}
